import {GraphLevel} from '@domain/rcfa'
import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'

export type ResponseType = {
  analysisId: number
  levels: GraphLevel[]
  selectedNodeId: number
}

export const QueryKey = 'graph-data'

export const useRemoveAttachment = (
  analysisId: string | undefined,
  nodeId: number,
  taskId?: string
) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (attachmentId: number) => {
      const path = taskId
        ? `/rootcausefailureanalysis/analyses/${analysisId}/tasks/${taskId}/attachments/${attachmentId}`
        : `/rootcausefailureanalysis/analyses/${analysisId}/tree/nodes/${nodeId}/attachments/${attachmentId}`
      return (await ApiClient.axiosInstance.delete<ResponseType>(path, {})).data
    },
    onSuccess: async (data: ResponseType) => {
      await queryClient.invalidateQueries({queryKey: ['node-detail']})
      await queryClient.invalidateQueries({queryKey: ['graph-data']})
      await queryClient.invalidateQueries({queryKey: ['analysis-detail']})
      await queryClient.invalidateQueries({queryKey: ['task-detail']})
      queryClient.removeQueries({queryKey: ['analysis-pdfsummary']})
      return data
    }
  })
}
